module.exports = __webpack_public_path__ + "static/media/marker_Note.3359ab51.png";